module.exports = __webpack_public_path__ + "static/media/tp2.0d5a91ba.jpg";